import { ApplicationState } from '../../../../../store';
import { getDocDetails } from '../../../../../utilities/documents';
import { getDisplayName } from '../../../../../utilities/formatting';
import { IProps } from '../types';

export default function getPropsFromState(state: ApplicationState): IProps {
  const { openModal } = state.ui;
  const { sponsorType, docType, sponsorKey, docKey, modalTitle, isFinanceDocumentModal, isFollowUpDocumentModal } =
    openModal || {};
  let rejectDocType = docType ? docType.split('reject-')[1] : '';
  // special case 'customRequest' has no docType only sponsorType
  if (rejectDocType === 'null') {
    rejectDocType = null;
  }

  const docs = {
    ...(isFinanceDocumentModal ? { ...state.student.financeDocuments } : {}),
    ...(isFollowUpDocumentModal ? { ...state.student.followUpDocuments } : {}),
    ...(!isFinanceDocumentModal && !isFollowUpDocumentModal ? { ...state.student.documents } : {}),
  };
  const docDetails = getDocDetails({
    docs,
    sponsorType,
    docType: rejectDocType ?? null,
    docKey: docKey ?? null,
    sponsorKey: sponsorKey ?? null,
  });

  return {
    docUserAccess: docDetails.userAccess,
    prevStatus: docDetails.prevStatus,
    sponsorType,
    docType: rejectDocType ?? null,
    sponsorKey: sponsorKey ?? null,
    docKey: docKey ?? null,
    modalTitle,
    userName: state.auth.student_number!,
    displayName: getDisplayName(state.auth, state.config),
    isFinanceDocumentModal: isFinanceDocumentModal ?? false,
    isFollowUpDocumentModal: isFollowUpDocumentModal ?? false,
    financeDocuments: state.student.financeDocuments,
    role: state.auth.role,
  } as IProps;
}
